// Single source of truth for timeline activity categories. Mirrors
// `templates_data.TIMELINE_COLORS` on the backend — keep them in sync
// when adding new categories. `value` matches what the API stores.
//
// Each category represents WHAT is happening (the activity), not WHO is
// responsible — ownership lives on `primary_owner` + `supporting_teams`.
import {
  Bonfire, Cutlery, MusicDoubleNote, Gift, ArrowRight, Box,
  Sparks, MediaImage, Flower, Group, MicrophoneSpeaking,
  SparkSolid, Bookmark, Shirt, BinFull, Car, Page,
} from 'iconoir-react';

export const TIMELINE_CATEGORIES = [
  // 17 distinguishable shades within the brand palette (pinks, beiges, mauves
  // only — May 2026 rebrand). Hex values mirrored in
  // backend/templates_data.py::TIMELINE_COLORS — keep both in sync.
  // Original 6 (kept first so existing data lands where users expect).
  { value: 'ceremony', label: 'Ceremony / Ritual', color: '#C49892', icon: Bonfire },          // deeper rose
  { value: 'meal', label: 'Meal / Catering', color: '#D4B896', icon: Cutlery },                // warm beige
  { value: 'entertainment', label: 'Entertainment', color: '#B59CA5', icon: MusicDoubleNote }, // light mauve
  { value: 'vendor', label: 'Vendor Arrival', color: '#B0A39C', icon: Gift },                  // warm putty
  { value: 'transition', label: 'Transition / Break', color: '#E5D5B7', icon: ArrowRight },    // cream
  { value: 'other', label: 'Other', color: '#A89890', icon: Page },                            // taupe
  // Operational additions.
  { value: 'logistics', label: 'Logistics', color: '#8F7480', icon: Box },                       // dusty plum
  { value: 'hair_makeup', label: 'Hair / Makeup', color: '#E8C4C0', icon: Sparks },              // light pink
  { value: 'photography_video', label: 'Photography / Video', color: '#9D8089', icon: MediaImage }, // deeper mauve
  { value: 'setup_styling', label: 'Setup / Styling', color: '#D6BFA0', icon: Flower },          // champagne
  { value: 'guest_experience', label: 'Guest Experience', color: '#C5B0BA', icon: Group },       // lavender mauve
  { value: 'audio_production', label: 'Audio / Production', color: '#7E6B72', icon: MicrophoneSpeaking }, // deep smoky mauve
  { value: 'important_moments', label: 'Important Moments', color: '#D1B0AB', icon: SparkSolid }, // dusty rose flagship
  { value: 'religious_cultural', label: 'Religious / Cultural', color: '#BFA88A', icon: Bookmark }, // khaki beige
  { value: 'beauty_wardrobe', label: 'Beauty / Wardrobe', color: '#C9A4A0', icon: Shirt },       // rose taupe
  { value: 'cleanup_strike', label: 'Cleanup / Strike', color: '#B5A8A8', icon: BinFull },       // cool taupe-mauve
  { value: 'transportation', label: 'Transportation', color: '#A1908C', icon: Car },             // warm gray-rose
];

export const getCategory = (value) =>
  TIMELINE_CATEGORIES.find((c) => c.value === value) || TIMELINE_CATEGORIES[TIMELINE_CATEGORIES.length - 6]; // 'other'

export const getCategoryColor = (value) => getCategory(value).color;
export const getCategoryLabel = (value) => getCategory(value).label;
export const getCategoryIcon = (value) => getCategory(value).icon;
